import { Search } from 'lucide-react';

interface CandidateSearchProps {
  value: string;
  onChange: (value: string) => void;
}

/** Narrows every stage on the page; the API matches name and email. */
export function CandidateSearch({ value, onChange }: CandidateSearchProps) {
  return (
    <label className="border-input focus-within:border-ring focus-within:ring-ring/50 flex h-8 w-full min-w-0 items-center gap-2 rounded-lg border px-2.5 text-[13px] text-neutral-500 transition-[color,box-shadow] focus-within:ring-[3px] @3xl:w-48">
      <Search aria-hidden className="size-4 shrink-0" />
      <input
        aria-label="Search candidates"
        autoFocus
        className="placeholder:text-input-placeholder text-foreground w-full bg-transparent outline-none"
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search candidates"
        type="search"
        value={value}
      />
    </label>
  );
}
